<template>
	<svg
		width="5"
		height="8"
		viewBox="0 0 5 8"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
		@click="next"
	>
		<path
			fill-rule="evenodd"
			clip-rule="evenodd"
			d="M0.853553 0.464562L4.03553 3.64654C4.2308 3.84181 4.2308 4.15839 4.03553 4.35365L0.853552 7.53563C0.65829 7.73089 0.341707 7.73089 0.146445 7.53563C-0.0488167 7.34037 -0.0488167 7.02378 0.146445 6.82852L2.97487 4.0001L0.146446 1.17167C-0.0488156 0.976407 -0.0488155 0.659824 0.146446 0.464562C0.341709 0.2693 0.658291 0.2693 0.853553 0.464562Z"
			fill="#E02D00"
		/>
	</svg>
</template>

<script>
export default {
	name: 'PaginateRight',
	props: {
		currentPage: {
			type: Number,
			required: true,
		},
		totalPages: {
			type: Number,
			required: true,
		},
	},
	methods: {
		next() {
			if (this.currentPage === this.totalPages) {
				return;
			}
			this.$emit('nextPage');
		},
	},
};
</script>
